// Collection artwork has a stable palette, independent of the playing track.
const chartHues: Record<string, number> = {
  'global-trending': 150, 'new-songs': 330, 'english-trending': 220,
  'chinese-trending': 18, 'french-trending': 340, 'korean-trending': 6,
  'japanese-trending': 46, 'spanish-trending': 262, 'german-trending': 196,
}
export const collectionHue = (slug: string): number => {
  const key = slug.split('/').filter(Boolean).pop()?.toLowerCase() || ''
  if (key in chartHues) return chartHues[key]
  return Array.from(key).reduce((hash, letter) => (hash * 31 + letter.charCodeAt(0)) % 360, 10)
}
